import { Backdrop, Badge, CircularProgress, Grid, makeStyles, Typography } from '@material-ui/core'
import { Link } from 'react-router-dom'
import Routes from '../../router'
import SaveOrCancelButtons from '../../components/saveOrCancelButtons'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  shortcutItem: {
    height: '11rem',
    backgroundColor: 'white',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(255, 23, 68, 0.04)',
      textDecoration: 'none'
    }
  }
}))

const Incidences = (props) => {
  const handleClose = props.onClose
  const classes = useStyles()
  const formTitle = 'Seleccionar tipo de incidencia'

  const shortcuts = Routes.map((route) => {
    if (route.children) {
      return [
        ...route.children.map((routeChildren) => {
          if (routeChildren.path && routeChildren.isIncidence) {
            return routeChildren
          }
          return []
        })
      ]
    }
    return []
  }).flat(Infinity)

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <h2>{formTitle}</h2>
        </Grid>
        <Grid container spacing={0} direction="row" alignItems="center">
          {shortcuts.map((route, index) => (
            <Grid key={`shortcuts-${index}`} item xs={4} md={4}>
              <Link
                to={route.path}
                className={
                  classes.shortcutItem + ' text-center border border-primary rounded m-2 d-flex'
                }
              >
                <div className="m-auto" style={{ width: '-webkit-fill-available' }}>
                  {route.count ? (
                    <Badge badgeContent={route.count} color="secondary">
                      <svg width="70" height="70">
                        {route.icon}
                      </svg>
                    </Badge>
                  ) : (
                    <svg width="70" height="70">
                      {route.icon}
                    </svg>
                  )}
                  <Typography variant="h6" color="secondary">
                    {route.title}
                  </Typography>
                </div>
              </Link>
            </Grid>
          ))}
        </Grid>
        <SaveOrCancelButtons onCancel={handleClose} cancelLabel="Cerrar" loading={false} />
      </Grid>
      <Backdrop className={classes.backdrop} open={false} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}

export default Incidences
